import type { CSSProperties } from 'react';
import type { IToastProperties } from './Toast';
import { IToastIcon } from './Toast';
import { ToastBackgroundColor, ToastTextColor } from './Toast.constants';
import styles from './Toast.module.css';

export enum StyleElement {
    Container = 'Container',
    Icon = 'Icon',
    Text = 'Text',
}

const DEFAULTS: Record<StyleElement, CSSProperties> = {
    [StyleElement.Container]: {},
    [StyleElement.Icon]: {},
    [StyleElement.Text]: {},
};

const PROPS_APPLICATOR: Record<StyleElement, (properties: IToastProperties) => CSSProperties> = {
    [StyleElement.Container]: (properties: IToastProperties) => ({
        backgroundColor: MapBackgroundColor(properties.icon),
    }),
    [StyleElement.Icon]: (properties: IToastProperties) => ({
        color: MapTextColor(properties.icon),
    }),
    [StyleElement.Text]: (properties: IToastProperties) => ({
        color: MapTextColor(properties.icon),
    }),
};

function MapBackgroundColor(inIcon: IToastIcon): string {
    switch (inIcon) {
        case IToastIcon.Error:
            return ToastBackgroundColor.Error;

        case IToastIcon.Warning:
            return ToastBackgroundColor.Warning;

        case IToastIcon.Success:
            return ToastBackgroundColor.Success;

        case IToastIcon.Information:
            return ToastBackgroundColor.Information;

        default:
            throw new Error(`Unrecognised type: ${inIcon}`);
    }
}

function MapTextColor(inIcon: IToastIcon): string {
    switch (inIcon) {
        case IToastIcon.Error:
            return ToastTextColor.Error;

        case IToastIcon.Warning:
            return ToastTextColor.Warning;

        case IToastIcon.Success:
            return ToastTextColor.Success;

        case IToastIcon.Information:
            return ToastTextColor.Success;

        default:
            throw new Error(`Unrecognised type: ${inIcon}`);
    }
}

export function classNameForElement(element: StyleElement, properties: IToastProperties): string {
    const name = element.toString();
    return styles[name] ?? '';
}

export function styleForElement(
    element: StyleElement,
    properties: IToastProperties,
): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](properties) };

    return style;
}
